import { useEffect, useState } from "react";
import {
  useCreateItem,
  useUpdateItem,
} from "../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import CuInput from "../../all-patient/components/CuInput";
import CuSpinner from "../../common_component/component/CuSpinner";
import CuSuggestionBox from "../../common_component/component/CuSuggestionBox";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { toast } from "react-toastify";
import { useItemsFilter } from "../../_helper/actions/app/items";
import moment from "moment";

const BatchForm = ({ mode, handleEdit, handleCancel, id }) => {
  const [clinic] = useAtom(clinicAtom);
  const [searchInput, setSearchInput] = useState({
    medicine_name: "",
  });
  const [formData, setFormData] = useState({
    // id: null,
    batch_number: null,
    description: "",
    medicine_name: "",
    medicine_id: null,
    date_of_manufactured: "",
    expiry_date: "",
    date_created: moment().format("YYYY-MM-DD"),
  });

  const clearSearch = () => {
    setSearchInput({
      medicine_name: "",
    });
  };

  const postMedicineStock = useCreateItem(ApiEndPoint.INVENTORY);
  const updateMedicineStock = useUpdateItem(ApiEndPoint.INVENTORY);

  const { data } = useItemsFilter(
    ApiEndPoint.INVENTORY,
    `?action=getBatchMaster&backend=True&clinic_id=${clinic?.id}&id=${id}`,
    clinic?.id && mode && id ? true : false
  );

  const { data: medicineData , isLoading: medicineLoading} = useItemsFilter(
    ApiEndPoint.QP_CM_MEDICINE_DATA,
    `?action=getMedicineData&medicine_name__icontains=${searchInput?.medicine_name}`,
    searchInput?.medicine_name?.length > 0 ? true : false
  );

  useEffect(() => {
    if (data) {
      setFormData({
        id: data?.id,
        batch_number: data?.batch_number,
        description: data?.description,
        medicine_name: data?.medicine_name,
        medicine_id: data?.medicine_id,
        date_of_manufactured: moment(data?.date_of_manufactured).format(
          "YYYY-MM-DD"
        ),
        expiry_date: moment(data?.expiry_date).format("YYYY-MM-DD"),
        date_created: moment(data?.date_created).format("YYYY-MM-DD"),
      });
    }
  }, [data]);

  const handleSave = (e) => {
    e.preventDefault();
    const action = mode === "edit" ? "patchBatchMaster" : "postBatchMaster";
    if (!formData?.medicine_id) {
      toast.error("Please select medicine from suggestion");
      return;
    }
    const payload = {
      action: action,
      id: formData?.id,
      backend: "True",
      clinic_id: clinic?.id,
      batch_number: formData.batch_number,
      description: formData?.description,
      medicine_name: formData?.medicine_name,
      medicine_id: formData?.medicine_id,
      date_of_manufactured: moment(formData?.date_of_manufactured).format(
        "YYYY-MM-DDTHH:mm:ss[Z]"
      ),
      expiry_date: moment(formData?.expiry_date).format(
        "YYYY-MM-DDTHH:mm:ss[Z]"
      ),
      // is_consumed: false,
    };

    if (mode === "edit") {
      updateMedicineStock.mutate(
        { data: payload },
        {
          onSuccess: () => {
            handleCancel();
          },
          onError: (err) => {
            toast.error(err.response.data.message);
          },
        }
      );
    } else {
      postMedicineStock.mutate(payload, {
        onSuccess: () => {
          handleCancel();
        },
        onError: (err) => {
          toast.error(err.response.data.message);
        },
      });
    }
  };

  const handleChange = (value, label) => {
    if (label === "medicine_name") {
      setSearchInput({ medicine_name: "", [label]: value });
    }
    if (label === "medicine") {
      setFormData((prev) => ({
        ...prev,
        medicine_name: value?.medicine_name,
        medicine_id: value?.id,
      }));
      clearSearch();
      return;
    }
    setFormData((prev) => ({ ...prev, [label]: value }));
  };

  return (
    <div className="cu-setup-create-container">
      <form className="cu-setup-create-form" onSubmit={handleSave}>
        <div className="cu-setup-create-form-input-container">
          <div className="cu-setup-create-form-input">
            <CuInput
              label="Batch No"
              required={true}
              placeholder="Enter Batch No"
              onChange={(e) => handleChange(e.target.value, "batch_number")}
              value={formData?.batch_number}
            />
          </div>
          <div className="cu-setup-create-form-input">
            <CuInput
              label="Description"
              onChange={(e) => handleChange(e.target.value, "description")}
              value={formData?.description}
            />
          </div>
          <div className="cu-setup-create-form-input">
            <CuSuggestionBox
              options={medicineData}
              renderKey={"medicine_name"}
              required={true}
              searchInput={searchInput?.medicine_name}
              loading={medicineLoading}
              label="Select Medicine"
              onChange={(val) => handleChange(val, "medicine_name")}
              handleSelectOption={(val) => handleChange(val, "medicine")}
              value={formData?.medicine_name}
            />
          </div>
          <div className="cu-setup-create-form-input">
            <CuInput
              label="Batch Creation Date"
              type="date"
              disabled={true}
              value={formData?.date_created}
            />
          </div>
          <div className="cu-setup-create-form-input">
            <CuInput
              label="Manufacture Date"
              type="date"
              // required={true}
              value={formData?.date_of_manufactured}
              onChange={(e) =>
                handleChange(e.target.value, "date_of_manufactured")
              }
            />
          </div>
          <div className="cu-setup-create-form-input">
            <CuInput
              label="Expiry"
              type="date"
              required={true}
              value={formData?.expiry_date}
              onChange={(e) => handleChange(e.target.value, "expiry_date")}
            />
          </div>
        </div>
        <div className="cu-setup-create-form-btn-container">
          {mode !== "view" && (
            <button
              className={`cu-setup-create-form-btn cu-setup-create-form-save-btn`}
              type="submit"
            >
              {postMedicineStock.isLoading || updateMedicineStock.isLoading ? (
                <CuSpinner />
              ) : (
                "Save"
              )}
            </button>
          )}
          {mode === "view" && (
            <button
              className={`cu-setup-create-form-btn cu-setup-create-form-save-btn`}
              type="submit"
              onClick={handleEdit}
            >
              Edit
            </button>
          )}
          <button
            className={`cu-setup-create-form-btn cu-setup-create-form-cancel-btn`}
            type="button"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default BatchForm;
